/** Faixas de desconto (%) por valor de coparticipação ou quantidade de vidas */

const TIERS_PRONTO_SOCORRO = [
  { min: 1, max: 20, percent: 1 },
  { min: 20.01, max: 40, percent: 2 },
  { min: 40.01, max: 60, percent: 3 },
  { min: 60.01, max: 80, percent: 4 },
  { min: 80.01, max: 100, percent: 5 },
  { min: 100.01, max: 120, percent: 6 },
  { min: 120.01, max: 140, percent: 7 },
  { min: 140.01, max: Infinity, percent: 8 }
];

const TIERS_INTERNACAO = [
  { min: 1, max: 100, percent: 1 },
  { min: 100.01, max: 200, percent: 2 },
  { min: 200.01, max: 300, percent: 3 },
  { min: 300.01, max: 400, percent: 4 },
  { min: 400.01, max: Infinity, percent: 5 }
];

const TIERS_CONSULTA_MEDICA = [
  { min: 1, max: 30, percent: 1 },
  { min: 30.01, max: 50, percent: 2 },
  { min: 50.01, max: 80, percent: 2.5 },
  { min: 80.01, max: Infinity, percent: 3 }
];

const TIERS_VIDAS = [
  { min: 0, max: 29, percent: 0 },
  { min: 30, max: 50, percent: 3.5 },
  { min: 51, max: 100, percent: 7 },
  { min: 101, max: 500, percent: 10 },
  { min: 501, max: Infinity, percent: 12 }
];

const clampPercent = (value) => Math.min(1, Math.max(0, value));

const getDiscountFromTiers = (value, tiers) => {
  const tier = tiers.find(({ min, max }) => value >= min && value <= max);
  return tier?.percent ?? 0;
};

const getDiscountIfPositive = (value, tiers) =>
  value > 0 ? getDiscountFromTiers(value, tiers) : 0;

export const parseCurrencyValue = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && value.length) {
    if (value.includes(',')) {
      const normalized = value.replace(/\./g, '').replace(',', '.');
      const parsed = Number(normalized);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    const parsed = Number(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

export const calcMensalidadeBase = (rangeValues, beneficiaries) =>
  rangeValues.reduce((sum, range) => {
    const qtde = Number(beneficiaries[range.label] || 0);
    const valor = parseCurrencyValue(range.valor);
    return sum + qtde * valor;
  }, 0);

export const applyDiscountToPrice = (valor, descontoTotalPercentual) =>
  Math.max(0, valor * (1 - descontoTotalPercentual));

/**
 * Soma dos % de desconto aplicados sobre a mensalidade base (mesma regra do preço de venda por faixa).
 */
export const calcQuotationDiscounts = ({
  coparticipation,
  mensalidadeBase,
  totalBeneficiaries,
  abrangenciaPromocional = 0,
  acrescimoValor = 0
}) => {
  const valorPS = parseCurrencyValue(coparticipation.hospital_pronto_socorro);
  const valorInternacao = parseCurrencyValue(coparticipation.hospital_internacao);
  const valorConsulta = parseCurrencyValue(coparticipation.amb_consulta_valor);

  const descontoPS = getDiscountIfPositive(valorPS, TIERS_PRONTO_SOCORRO);
  const descontoInternacao = getDiscountIfPositive(valorInternacao, TIERS_INTERNACAO);
  const descontoConsultaMedica = getDiscountIfPositive(valorConsulta, TIERS_CONSULTA_MEDICA);
  const descontoVidas = getDiscountFromTiers(totalBeneficiaries, TIERS_VIDAS);

  const base = Math.max(0, mensalidadeBase);
  const descontoTotalPercentual = clampPercent(
    (descontoPS +
      descontoInternacao +
      descontoConsultaMedica +
      descontoVidas +
      abrangenciaPromocional -
      acrescimoValor) /
      100
  );
  const valorFinal = Math.max(0, base * (1 - descontoTotalPercentual));

  return {
    mensalidadeBase: base,
    valorFinal,
    descontoTotalPercentual,
    descontoPS,
    descontoInternacao,
    descontoConsultaMedica
  };
};
